/**
 * Fetch z obsługą błędów i zwracaniem danych w tablicy
 * @param url - Adres docelowy
 * @param options - Opcje fetch
 * @returns Tablica z danymi i błędem
 */
export async function useFetchWithTryCatch(url, options = {}) {
	try {
		const response = await fetch(url, options);

		if (!response.ok) { // Check for HTTP errors (status outside 200-299)
			const error = new Error(`HTTP error! status: ${response.status}`);
			error.response = response; // Attach the response to the error for more details
			throw error; // Re-throw the error to be caught by the caller
		}

		const data = await response.json(); // Or response.text() if expecting plain text
		return [data, null]; // Return data and null for error
	} catch (error) {
		return [null, error]; // Return null for data and the error
	}
}

/**
 * Wyciąga nazwę pliku z adresu URL
 * @param url
 * @returns nazwa pliku
 */
export function getFilenameFromUrl(url) {
	const result = url.match(/(?=[^\/]{1,}\.\w{3,4}$).+/g);
	return result?.[0];
}

/**
 * Przelicza rozmiar podany w odpowiedniej jednostce do bajtów
 */
export function sizeToBytes(size: number, unit: 'KB' | 'MB' | 'GB' | 'TB') {
	const units = ['KM', 'MB', 'GB', 'TB'];
	const unitIdx = units.indexOf(unit);
	return size * 1024 ** (unitIdx + 1);
}

/**
 * Kopiuje tekst do schowka.
 * @param text Tekst do skopiowania
 */
export async function copyToClipboard(text: string) {
	if (navigator.clipboard) {
		await navigator.clipboard.writeText(text);
		return;
	}

	const el = document.createElement('textarea');
	el.value = text;
	document.body.appendChild(el);
	el.select();
	document.execCommand('copy');
	document.body.removeChild(el);
}

export function shareUrl(url: string, title: string) {
	if (window.navigator.share && window.innerWidth < 768) {
		window.navigator.share({ title, text: '', url });
		return true;
	}
	return false;
}

export function downloadUrl(url: string, filename: string) {
	const link = document.createElement('a');
	link.href = url;
	if (filename) {
		link.download = filename;
	}
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
}
/**
 * UWAGA stosuj tylko wtedy gdy CORSY się zgadzają
 * @param url 
 * @param fileName 
 */
export async function downloadWithBlob(url: string, fileName?: string) {
	const defaultFileName = fileName || getFilenameFromUrl(url) || 'downloaded_file';
	try {
		// Krok 1: Pobierz plik (to wymaga poprawnego CORS na serwerze!)
		const response = await fetch(url);
		if (!response.ok) {
			throw new Error(`Błąd sieci: ${response.statusText}`);
		}

		// Krok 2: Konwertuj na Blob
		const blob = await response.blob();

		// Krok 3: Stwórz lokalny URL
		const objectUrl = URL.createObjectURL(blob);

		// Krok 4 & 5: Stwórz i "kliknij" link
		downloadUrl(objectUrl, defaultFileName);

		URL.revokeObjectURL(objectUrl);
	} catch (error) {
		console.error('Pobieranie pliku nie powiodło się:', error);
	}
}
export function GetMailboxUrl(s: string) {
	if (!s || s.indexOf('@') === -1) { return ''; }
	s = s.split('@')[1];

	const list = {
		'wp.pl': 'profil.wp.pl',
		'wp.eu': 'profil.wp.pl',
		'poczta.wp.pl': 'profil.wp.pl',
		'xl.wp.pl': 'profil.wp.pl',
		'gmail.com': 'gmail.com',
		'googlemail.com': 'gmail.com',
		'o2.pl': 'poczta.o2.pl',
		'prokonto.pl': 'poczta.o2.pl',
		'go2.pl': 'poczta.o2.pl',
		'tlen.pl': 'poczta.o2.pl',
		'interia.pl': 'poczta.interia.pl',
		'interia.eu': 'poczta.interia.pl',
		'interia.com': 'poczta.interia.pl',
		'onet.pl': 'konto.onet.pl',
		'op.pl': 'konto.onet.pl',
		'buziaczek.pl': 'konto.onet.pl',
		'amorki.pl': 'konto.onet.pl',
		'poczta.onet.eu': 'konto.onet.pl',
		'poczta.onet.pl': 'konto.onet.pl',
		'onet.eu': 'konto.onet.pl',
		'autograf.pl': 'konto.onet.pl',
		'vip.onet.pl': 'konto.onet.pl',
		'spoko.pl': 'konto.onet.pl',
		'onet.com.pl': 'konto.onet.pl',
		'vp.pl': 'konto.onet.pl',
		'adres.pl': 'konto.onet.pl',
		'opoczta.pl': 'konto.onet.pl',
		'outlook.com': 'outlook.live.com',
		'hotmail.com': 'outlook.live.com',
		'gazeta.pl': 'oauth.gazeta.pl',
		'g.pl': 'oauth.gazeta.pl',
		'yahoo.com': 'login.yahoo.com',
		'yahoo.pl': 'login.yahoo.com',
		'yahoo.co.uk': 'login.yahoo.com',
		'icloud.com': 'icloud.com',
		'neostrada.pl': 'webmail.neostrada.pl',
		'mail.ru': 'mail.ru',
		'bk.ru': 'mail.ru',
		'inbox.ru': 'mail.ru',
		'yandex.ru': 'passport.yandex.ru',
		'ukr.net': 'mail.ukr.net',
		'post.pl': 'login.poczta.home.pl',
		'home.pl': 'login.poczta.home.pl',
		'data.pl': 'login.poczta.home.pl',
		'list.pl': 'login.poczta.home.pl',
		'rambler.ru': 'games.rambler.ru',
		'orange.pl': 'poczta.orange.pl',
		'int.pl': 'int.pl',
		'gmx.de': 'gmx.de',
	};

	return list[s] ? (`//${list[s]}`) : 'Nie znaleziono serwisu pocztowego dla tego adresu email';
}

/**
 * Zamienia tekst (np. tytuł) na URL-friendly "slug" (bez polskich znaków, bez spacji, z myślnikami)
 * @param text Tekst do konwersji (np. tytuł RFP)
 * @returns slug, np. "Wycena drzwi & okna" => "wycena-drzwi-okna"
 */
export function slugify(text: string): string {
	return text
		.replace(/ą/g, 'a')
		.replace(/ć/g, 'c')
		.replace(/ę/g, 'e')
		.replace(/ł/g, 'l')
		.replace(/ń/g, 'n')
		.replace(/ó/g, 'o')
		.replace(/ś/g, 's')
		.replace(/ż|ź/g, 'z')
		.replace(/[^a-zA-Z0-9]+/g, '-')
		.replace(/^-+|-+$/g, '')
		.replace(/--+/g, '-');
}
